import {
  createActivePublicationResolver,
} from "../../engines/ActivePublicationResolver";

import {
  createPublicationRuntimeBridge,
} from "../../engines/PublicationRuntimeBridge";

import {
  createStudioPublicationAdapterRegistry,
} from "../../engines/StudioPublicationAdapterRegistry";

import {
  retailPublicationAdapter,
} from "./retailPublicationAdapter";

import {
  createRetailStudioPublicationBinding,
} from "./retailStudioPublicationBinding";


/**
 * Retail POS Publication Production Composition.
 *
 * This composition is stateless.
 *
 * It owns no publication data and creates no new business engine.
 *
 * Responsibilities:
 *
 * - compose ActivePublicationResolver;
 * - register the existing Retail Publication Adapter;
 * - compose PublicationRuntimeBridge;
 * - expose the resulting publication runtime boundary.
 *
 * Explicitly excluded:
 *
 * - publication persistence;
 * - publication mutation;
 * - Studio draft ownership;
 * - RetailStudioDocument duplication;
 * - POSDomainRegistry ownership;
 * - POSActivityHost ownership;
 * - React state ownership.
 */
export function createRetailPOSPublicationComposition({
  publicationEngine,
  getVersion,
  resolveStudioReference = null,
  listDocuments = null,
  createDescriptorId,
} = {}) {
  const publicationBinding =
    resolveStudioReference === null
      ? createRetailStudioPublicationBinding({
          listDocuments,
        })
      : null;

  const resolvedStudioReference =
    resolveStudioReference
    ?? publicationBinding
      .resolveStudioReference;

  const activePublicationResolver =
    createActivePublicationResolver({
      publicationEngine,
      getVersion,
      resolveStudioReference:
        resolvedStudioReference,
      ...(createDescriptorId
        ? {
            createDescriptorId,
          }
        : {}),
    });

  const publicationAdapterRegistry =
    createStudioPublicationAdapterRegistry({
      adapters: [
        retailPublicationAdapter,
      ],
    });

  const publicationRuntimeBridge =
    createPublicationRuntimeBridge({
      activePublicationResolver,
      publicationAdapterRegistry,
    });

  return Object.freeze({
    activePublicationResolver,
    publicationAdapterRegistry,
    publicationRuntimeBridge,
  });
}


export default createRetailPOSPublicationComposition;
